import {Component,OnInit} from '@angular/core';
import {FormulaireVoyageService} from "@components/admin/parametre/formulaire/formulaire-voyage/formulaire-voyage.service";
import {BehaviorSubject} from "rxjs";
import {FloatingButtonAction,TypeAction} from "@share/component/floating-button/floating-button";

/**
 * Composant d'affichage de la page formulaire pour le voyage
 *
 * @author Lionel Gimenez
 * @date 11/09/2025
 */
@Component({
    host: {'data-test-id': 'formulaire-voyage'},
    selector: 'formulaire-voyage',
    templateUrl: './formulaire-voyage.component.html'
})
export class FormulaireVoyageComponent implements OnInit {
    /** Liste des actions possibles */
    listeActions: BehaviorSubject<Array<FloatingButtonAction>> = new BehaviorSubject<Array<FloatingButtonAction>>(null);

    /**
     * Constructeur
     */
    constructor(
        public formulaireVoyageService: FormulaireVoyageService,
    ) {
    }

    /**
     * Initialisation
     */
    ngOnInit(): void {
        //Chargement des données
        this.formulaireVoyageService.load();

        //Initialisation des actions possibles
        this.listeActions.next([{
            type: TypeAction.PRIMARY,
            icone: 'nio icon-sauvegarde',
            libelle: 'global.actions.enregistrer',
            doAction: () => this.formulaireVoyageService.save(),
        }]);
    }
}
